import { Container } from "@mui/material"
import { styled } from "@mui/material/styles"

const NewsListWrapperContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
}))

export { NewsListWrapperContainer }
